<template>
  <form onsubmit="return false;">
    <generic-profile-info v-model="model"></generic-profile-info>
  </form>
</template>

<script>
import GenericProfileInfo from "../../../../components/shared/GenericProfileInfo.vue";
import GenericUserInfo from "../../../../components/shared/GenericUserInfo.vue";

export default {
  name: "AccountInfo",
  components: {GenericUserInfo, GenericProfileInfo},
  props: {
    value: {
      type: [Object],
      required: true,
    },
    dateOption: true
  },
  data() {
    return {
      model: this.clone(this.value),
    };
  },
  watch: {
    model: {
      deep: true,
      handler(value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>

<style scoped>

</style>